function stableStringify(value: any): string {
  const seen = new WeakSet<object>()
  const walk = (v: any): any => {
    if (v && typeof v === "object") {
      if (seen.has(v)) return "[Circular]"
      seen.add(v)
      if (Array.isArray(v)) return v.map(walk)
      const out: Record<string, any> = {}
      for (const k of Object.keys(v).sort()) {
        out[k] = walk(v[k])
      }
      return out
    }
    if (typeof v === "function") return "[Function]"
    if (typeof v === "bigint") return v.toString()
    return v
  }
  return JSON.stringify(walk(value))
}

function hashString(input: string): string {
  let h = 2166136261
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return (h >>> 0).toString(16).padStart(8, "0")
}

export function generateId(item: unknown): string {
  try {
    const str = stableStringify(item)
    return `gen_${hashString(str)}`
  } catch {
    return `gen_${Math.random().toString(16).slice(2)}`
  }
}

export function extractItemId(item: any): string {
  const candidate = item?.id ?? item?.slug ?? item?.name
  if (typeof candidate === "string" && candidate.trim()) return candidate.trim()
  if (typeof candidate === "number" && Number.isFinite(candidate)) return String(candidate)
  return generateId(item)
}

